<template>
  <v-card id="notification-settings">
    <v-card-title class="text-h6">
      Настройки уведомлений
    </v-card-title>

    <v-card-text v-if="!loaded">
      <v-progress-linear indeterminate></v-progress-linear>
    </v-card-text>

    <v-card-text v-else-if="!isConnected">
      <v-alert
        type="warning"
        text
        dense
        class="mb-0"
      >
        {{ unavailableReason || 'Сервис уведомлений не подключён или не отвечает.' }}
      </v-alert>
    </v-card-text>

    <template v-else>
      <v-tabs
        v-model="tab"
        show-arrows
      >
        <v-tab>
          <v-icon
            size="20"
            class="me-3"
          >
            {{ icons.mdiCellphone }}
          </v-icon>
          <span>Приложение</span>
        </v-tab>
        <v-tab>
          <v-icon
            size="20"
            class="me-3"
          >
            {{ icons.mdiWeb }}
          </v-icon>
          <span>Браузер</span>
        </v-tab>
        <v-tab>
          <v-icon
            size="20"
            class="me-3"
          >
            {{ icons.mdiMessageTextOutline }}
          </v-icon>
          <span>SMS</span>
        </v-tab>
        <v-tab>
          <v-icon
            size="20"
            class="me-3"
          >
            {{ icons.mdiBullhornOutline }}
          </v-icon>
          <span>Рассылки</span>
        </v-tab>
        <v-tab>
          <v-icon
            size="20"
            class="me-3"
          >
            {{ icons.mdiFileDocumentEditOutline }}
          </v-icon>
          <span>Шаблоны</span>
        </v-tab>
        <v-tab>
          <v-icon
            size="20"
            class="me-3"
          >
            {{ icons.mdiBellRingOutline }}
          </v-icon>
          <span>Автоматические</span>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <mobile-push-setting-form></mobile-push-setting-form>
        </v-tab-item>
        <v-tab-item>
          <web-push-setting-form></web-push-setting-form>
        </v-tab-item>
        <v-tab-item>
          <sms-setting-form></sms-setting-form>
        </v-tab-item>
        <v-tab-item>
          <campaign-setting-form></campaign-setting-form>
        </v-tab-item>
        <v-tab-item>
          <template-setting-form></template-setting-form>
        </v-tab-item>
        <v-tab-item>
          <event-setting-form></event-setting-form>
        </v-tab-item>
      </v-tabs-items>
    </template>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import {
  mdiCellphone,
  mdiWeb,
  mdiMessageTextOutline,
  mdiBullhornOutline,
  mdiFileDocumentEditOutline,
  mdiBellRingOutline,
} from '@mdi/js'

import MobilePushSettingForm from '@/views/notification-settings/mobile-push-setting-form.vue'
import WebPushSettingForm from '@/views/notification-settings/web-push-setting-form.vue'
import SmsSettingForm from '@/views/notification-settings/sms-setting-form.vue'
import CampaignSettingForm from '@/views/notification-settings/campaign-setting-form.vue'
import TemplateSettingForm from '@/views/notification-settings/template-setting-form.vue'
import EventSettingForm from '@/views/notification-settings/event-setting-form.vue'

export default {
  name: 'NotificationSettings',
  components: {
    MobilePushSettingForm,
    WebPushSettingForm,
    SmsSettingForm,
    CampaignSettingForm,
    TemplateSettingForm,
    EventSettingForm,
  },
  data: () => ({
    icons: {
      mdiCellphone,
      mdiWeb,
      mdiMessageTextOutline,
      mdiBullhornOutline,
      mdiFileDocumentEditOutline,
      mdiBellRingOutline,
    },
    tab: null,
  }),
  computed: {
    ...mapState('notificationSettings', ['loaded', 'isConnected', 'unavailableReason']),
  },
  async created() {
    document.title = 'Настройки уведомлений'
    await this.fetch()
  },
  methods: {
    ...mapActions('notificationSettings', ['fetch']),
  },
}
</script>
